import axios from "axios";
import { get_access_token } from "./get_access_token"

export const createUser = async (userData) => {
  const access_token = await get_access_token("");
  const apiUrl = process.env.REACT_APP_API_URL;

  let data = await axios({
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": access_token,
  },
    url: `${apiUrl}/api/profile/create_user`,
    params: {
      user: userData
    },
  });

  // name:"",
  // surname:"",
  // lastname:"",
  // email:"",
  // user_name:"",
  // birthDateYear:"1940",
  // birthDateMonth:"1",
  // birthDateDay:"1",
  // docExpirationYear:"2030",
  // docExpirationMonth:"1",
  // docType: "D",
  // nationality: "ESP",
  // docNumber: ""

  const result = data.data

  return result;
};
